<template>
  <div>
    <populate-form
      formTitle="新增自訂類型保留預約"
      fkey="pra01"
      ref="addForm"
      populateOptionVar="addOptions"
      formDataObjVar="addData"
      @customValueChanged="optionChanged"
    ></populate-form>
  </div>
</template>

<script>

/*
  用modal開啟的新增店家私人劃位組件

  組件要自行載入此店家專屬的自訂外部預約類型(並可以連結跳過去)
  下拉選擇外部預約類型,填寫開始時間和結束時間(popup開啟時應可帶入開始時間並自動依類型計算結束時間)
  填寫備註按存檔就呼叫api完成新增,新增成功時parent要by日期整個reload

  此組件難點在於time picker不好用如何改善體驗
  用type=range的input,不好拖拉,還需要把時間分鐘數轉換成拖曳單位,才時實現需要的step且step也是動態的
  用datetime picker則很難控制用戶輸入無效的分鐘數(10:47不可能有效),也是很難用
  選擇開始結束時間有幾種可能的操作方式：
  如IOS的datetime picker,上下捲,可以透過排除選項達成step,但據說有專利而且也不是很容易實現
  用mask text input限制輸入4個數字並提供leave時的validate,熟練的用戶這樣效率最好但需要教學與學習
  自己刻一個time picker的小組件,可以透過設定控制時分秒的選項,上下鍵盤切換,點擊則彈出該項目所有選項
  =>用vue-timepicker組件了,內部實作有點機車,大幅修改後才能使用

  目前已完成顯示累積劃位熱度與對應劃位紀錄的顯示
  與新增私人預約的功能
  TODO:
  邀請預約popup與劃位紀錄link點擊的編輯(看詳細,取消/改時間等)的popup


*/
export default {
  name: 'AddPrivateReserve',
  props: {
    'target_date':String,
    'filter_start_time':String,
    'op_hours':Array,
    'minuteInterval':Number,
    'cancel_create':Function,
    'successReload':Function
  },
  data: function () {
    return {
      // addDate:null,
      extSrcTypes:[],
      addData:{},
      addOptions:[
        {
          componentType:'b-form-select',
          col:8,
          akey:'selectedType',
          defaultValue:null,
          placeholder:"請選擇",
          optionVar:'extSrcTypes',
          optionLabel:'ext_src_type_name',
        },
        {
          componentType:'date-picker',
          akey:'add_date',
          col:4,
          defaultValue:this.addDate,
          placeholder:""
        },
        {
          componentType:'vue-timepicker',
          col:4,
          akey:'start_time',
          placeholder:"選擇開始時間",
          defaultValue:"",
          minuteInterval:this.minuteInterval,
          minHour:8,
          maxHour:23,
        },
        {
          componentType:'vue-timepicker',
          col:4,
          akey:'end_time',
          placeholder:"選擇結束時間",
          defaultValue:"",
          minuteInterval:this.minuteInterval,
          minHour:8,
          maxHour:23,
        },
        {
          componentType:'span',
          col:4,
          title:'自訂類型有設定時間的會帶出結束時間',
          placeholder:"hint",
          hide:this.checkMobile()
        },
        {
          componentType:'span',
          col:3,
          placeholder:"自訂備註"
        },
        {
          componentType:'text',
          col:9,
          akey:'remark',
          placeholder:"私人保留劃位備註",
          defaultValue:""
        },
        {
          componentType:'span',
          col:3,
          placeholder:"",
          hide:this.checkMobile()
        },
        {
          componentType:'btn-group',
          akey:'btn-group',
          col:7,
          buttons:[
            {
              akey:"btnCancel",
              col:5,
              placeholder: "取消",
              execCallback: this.cancelCreate
            },
            {
              akey:"btnConfirm",
              col:5,
              placeholder: "建立",
              execCallback: this.createReserve
            }
          ]
        },
      ]
    }
  },
  methods: {
    createReserve() {
      // 檢查必填
      if (this.addData.selectedType === null || !this.addData.start_time || !this.addData.end_time) {
        this.$refs.addForm.triggerAlert("請填寫完整"+this.addData.selectedType)
        return
      }
      if (this.addData.start_time >= this.addData.end_time) {
        this.$refs.addForm.triggerAlert("結束時間必須晚於開始時間")
        return
      }
      // 雖然好像有點規律出現時間少秒數的情況,但一下子沒找到根本原因,所以先動態判斷補滿
      let start_time = this.addData.start_time
      let end_time = this.addData.end_time
      start_time += (start_time.length===8?'':':00')
      end_time += (end_time.length===8?'':':00')
      //呼叫api新增外部自訂保留劃位
      let Param = {
        'module':'store',
        'method':'addCustomReserve',
        'store_id': this.$bus.session.merchant_store_id,
        'start_time':this.addData.add_date+' '+start_time,
        'end_time':this.addData.add_date+' '+end_time,
        'category_id':this.addData.selectedType.id,
        'remark':this.addData.remark
      }
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
          vm.$refs.addForm.triggerAlert(data.msg)
          return
        }
        // 應呼叫done refresh
        vm.successReload(vm.target_date!==vm.addData.add_date?vm.addData.add_date:undefined)
      }, this)
    },
    cancelCreate() {
      this.cancel_create()
    },
    optionChanged(upd) {
      if (upd.key === 'start_time') {
        // 根據extSrcType裡設定的分鐘數(如果有設定值不是0)自動計算更新end_time
        if (this.addData.selectedType !== null && this.addData.selectedType.default_minutes > 0) {
          let starttime_arr = upd.val.split(':')
          let final_minutes = parseInt(starttime_arr[0])*60+(starttime_arr[1]?parseInt(starttime_arr[1]):0)+this.addData.selectedType.default_minutes
          let end_time_str = (final_minutes/60 < 10?'0':'')+Math.floor(final_minutes/60)+':'+ (final_minutes%60 < 10?'0':'')+final_minutes%60
          this.setData('end_time',end_time_str)
        }
        // 無套用時間的類型,當已選取結束時間早於剛點選的開始時間,則自動清除省得送出時被檢查踢回來
        if (upd.val > this.addData.end_time) {
          this.setData('end_time',null)
        }
      }
      // 有時候(= =)start_time沒設定會抓到00:00:00,而非一定是空字串,這樣會帶出02:00的結束時間...
      else if (upd.key === 'selectedType' && upd.val !== null && this.addData.start_time !== '' && this.addData.start_time !== '00:00:00' && this.addData.selectedType.default_minutes > 0) {
        let starttime_arr = this.addData.start_time.split(':')
        let final_minutes = parseInt(starttime_arr[0])*60+(starttime_arr[1]?parseInt(starttime_arr[1]):0)+this.addData.selectedType.default_minutes
        let end_time_str = (final_minutes/60 < 10?'0':'')+Math.floor(final_minutes/60)+':'+ (final_minutes%60 < 10?'0':'')+final_minutes%60
        this.setData('end_time',end_time_str)
      }
    },
    setData(key, value) {
      // 被parent透過$refs更新指定一個屬性
      this.addData[key] = value
      this.$refs.addForm.refreshModelVar(key)
    },
    initDefault() {
      // addOptions裡的minuteInterval要reset(剛進來時prop的值沒準備好)
      for (let i=0;i<this.addOptions.length;i++) {
        if (this.addOptions[i].componentType === 'vue-timepicker') {
          this.addOptions[i].minuteInterval = this.minuteInterval
          this.addOptions[i].minHour = this.op_hours[0].hour
          this.addOptions[i].maxHour = this.op_hours[this.op_hours.length-1].hour
        }
      }
      this.addData.add_date = this.target_date
      this.addData.end_time = null
      this.addData.start_time = this.filter_start_time
      this.addData.selectedType = this.extSrcTypes[0]
      this.$refs.addForm.refreshModelVar()
    },
    loadSrcTypes() {
      if (!this.$bus.session.hasOwnProperty('store_ext_src_types')) {
        let Param = {
          'module':'store',
          'method':'getExtSrcTypes',
          'store_id': this.$bus.session.merchant_store_id,
        }
        this.$bus.apiCall(Param, function (data, vm) {
          if (data.ok === 0) {
            vm.$bus.fnShowInfo(data.msg)
            return
          }
          //直接當dataOptions用
          vm.$bus.session.store_ext_src_types = data.data
        }, this)
      }
    },
  },
  computed: {
    
  },
  created() {

  },
  mounted () {
    this.loadSrcTypes()
    setTimeout(() => {
      this.extSrcTypes = this.$bus.session.store_ext_src_types
      this.addData.selectedType = null
      this.addData.end_time = null
      this.$refs.addForm.refreshModelVar('selectedType')
    }, 100);
  },
  watch:{
  
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
